<template>
  <div
    class="pc__live-chat"
    id="pc__live-chat"
    :style="{ ...position }"
  >
    <div class="pc__live-chat__tool-bar">
      <div class="tool-bar__left chat-name">Chat List</div>
      <div class="tool-bar__right">
        <span class="chat-name">
          {{ storeInfo?.store_name || '' }}
          <span class="reconnect" v-if="useConnectStatus().value !== 'success'">
            <van-icon name="warning-o" size="12" />
            <span class="status">
              {{ 
                useConnectStatus().value === 'disconnect'
                  ? 'Disconnect'
                  : useConnectStatus().value === 'reconnecting'
                    ? 'Reconnecting'
                    : 'Connection failed'
              }}
            </span>
          </span>
        </span>
        <span class="chat-close" @click="handleCloseClick">
          <van-icon name="cross" size="22" />
        </span>
      </div>
    </div>

    <div class="pc__live-chat__wrapper">
      <div class="pc__live-chat__room-list">
        <div
          v-for="item in roomList"
          :key="item.room_id"
          :class="
            usePCCurrentChatRoom().value?.room_id === item.room_id
              ? 'room-list__item room-list__item-act'
              : 'room-list__item'
          "
          @click="handleRoomClick(item)"
        >
          <van-badge :content="item.not_read_count" :max="99" :show-zero="false">
            <img :src="$cvWebpFn(item.extra_info.store_info.store_icon)" alt="" class="room-list__store-icon">
          </van-badge>

          <div class="room-list__content">
            <p class="room-list__store-name">
              <span>{{ item.extra_info.store_info.store_name }}</span>
              <!-- <span class="room-list__time" v-if="item.last_message">
                {{ item.last_message_content?.msgDate }}
              </span> -->
            </p>
            <template v-if="item.last_message">
              <p class="room-list__store-msg">{{ item.last_message_content?.msgContentSummary }}</p>
            </template>
          </div>
        </div>
      </div>

      <div class="pc__live-chat__chat-content">
        <ChatContent />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ChatContent from './ChatContent.vue'

const { $msgSocket, $throttle } = useNuxtApp()
const roomList = useRoomList()
const popupW = '960px'
const popupH = '76vh'

const position = reactive({
  top: '0px',
  left: '0px',
  width: '0px',
  height: '0px',
  opacity: '0',
})

const initPos = () => {
  position.left = `calc((100vw - ${popupW}) / 2)`
  position.top = `calc((100vh - ${popupH}) / 2)`
}

watch(
  () => usePCLiveChatPopupShow().value,
  async() => {
    const val = usePCLiveChatPopupShow().value

    if(!val) {
      position.width = '0px'
      position.height = '0px'
      await nextTick()
      position.opacity = '0'

      usePCOpenRoomInfo().value = null
      const lastRid = usePCCurrentChatRoom().value?.room_id
      if(lastRid) {
        $msgSocket.exitRoomAsync(lastRid as string, () => { console.info(lastRid, '退出成功') })
      }
    } else {
      $msgSocket.createSocket(useNuxtApp())
      
      position.width = popupW
      position.height = popupH
      await nextTick()
      position.opacity = '1'

      initPos()
    }
  }
)

watch(
  () => usePCCurrentChatRoom().value,
  (val: Msg.IRoom | null) => {
    
    const oldRid = useCookie('msg__current_room_id').value

    if(oldRid && oldRid !== val?.room_id) {
      $msgSocket?.exitRoomAsync(oldRid, () => { console.info(oldRid, '退出成功') })
    }

    useCookie('msg__current_room_id').value = val ? val.room_id : ''
  }
)

let draggingClear: () => void
onMounted(() => {
  initPos()

  draggingClear = dragging()
})

onBeforeMount(() => {
  draggingClear && draggingClear()
  
  const roomId = useCookie('msg__current_room_id').value
  if(roomId && $msgSocket) {
    $msgSocket.exitRoomAsync(roomId, () => { console.info(roomId, '退出成功') })
  }
})

const storeInfo = computed(() => usePCCurrentChatRoom().value?.extra_info.store_info)
const handleRoomClick = (item: Msg.IRoom) => {
  usePCCurrentChatRoom().value = item
}

const handleCloseClick = () => {
  usePCLiveChatPopupShow().value = false
}

/** 拖拽功能 */
const dragging = function (): () => void {
  const toolBarEl = document.querySelector('.pc__live-chat__tool-bar') as HTMLElement
  const popupEl = document.getElementById('pc__live-chat') as HTMLElement

  let lastPos = { x: 0, y: 0 }
  let state: 'down' | 'move' | 'up' = 'up'
  const handleMouseDown = (e: MouseEvent) => {
    state = 'down'

    lastPos = { x: e.clientX, y: e.clientY }
  }
  const handleMouseUp = (e: MouseEvent) => {
    state = 'up'
  }
  const handleMouseMove = $throttle((e: MouseEvent) => {
    if(state === 'down' || state === 'move') {
      const { clientX, clientY } = e

      const offsetX = clientX - lastPos.x
      const offsetY = clientY - lastPos.y
      
      const top = popupEl.offsetTop + offsetY
      if(top >= 0) {
        position.top = `${popupEl.offsetTop + offsetY}px`
      }
      
      position.left = `${popupEl.offsetLeft + offsetX}px`

      lastPos.x = clientX
      lastPos.y = clientY

      state = 'move'
    }
  }, 15)

  toolBarEl.addEventListener('mousedown', handleMouseDown)
  document.addEventListener('mouseup', handleMouseUp)
  document.addEventListener('mousemove', handleMouseMove)

  return () => {
    toolBarEl.removeEventListener('mousedown', handleMouseDown)
    toolBarEl.removeEventListener('mouseup', handleMouseUp)
    toolBarEl.removeEventListener('mousemove', handleMouseMove)    
  }
}
</script>

<style lang="scss">
@import url('./index.scss');
</style>
